import React, { useContext, useEffect, useReducer, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { default as ReactSelect } from "react-select";
import { toast } from "react-toastify";
import { Store } from "../Store";
import useAxios from "../hooks/useAxios";
import { capitalize, getError } from "../utils";
import LoadingBox from "./LoadingBox";
import MessageBox from "./MessageBox";
import Option from "./Option";

const reducer = (state, action) => {
  switch (action.type) {
    case "CREATE_REQUEST":
      return { ...state, loadingCreate: true };
    case "CREATE_SUCCESS":
      return {
        ...state,
        loadingCreate: false,
      };
    case "CREATE_FAIL":
      return { ...state, loadingCreate: false };
    case "FETCH_REQUEST":
      return { ...state, loading: true };
    case "FETCH_SUCCESS":
      return { ...state, loading: false };
    case "FETCH_FAIL":
      return { ...state, loading: false, error: action.payload };
    case "UPDATE_REQUEST":
      return { ...state, loadingUpdate: true };
    case "UPDATE_SUCCESS":
      return { ...state, loadingUpdate: false };
    case "UPDATE_FAIL":
      return { ...state, loadingUpdate: false };
    case "UPLOAD_REQUEST":
      return { ...state, loadingUpload: true, errorUpload: "" };
    case "UPLOAD_SUCCESS":
      return {
        ...state,
        loadingUpload: false,
        errorUpload: "",
      };
    case "UPLOAD_FAIL":
      return { ...state, loadingUpload: false, errorUpload: action.payload };

    default:
      return state;
  }
};
export default function CompartmentEditor(props) {
  const axios = useAxios();
  const {
    setShowCompartmentEditor,
    setCompartmentEditorOperationOk,
    compartments,
    selectedCompartment,
    leafCategories,
  } = props;

  const { state } = useContext(Store);
  const { userInfo } = state;
  const [
    { loading, error, loadingUpdate, loadingUpload, loadingCreate },
    dispatch,
  ] = useReducer(reducer, {
    loading: false,
    error: "",
    loadingCreate: false,
    loadingUpdate: false,
  });

  const [name, setName] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [formValidated, setFormValidated] = useState(false);
  const [startNum, setStartNum] = useState(1);
  const [endNum, setEndNum] = useState(40);

  useEffect(() => {
    if (selectedCompartment) {
      setName(selectedCompartment.name);
      setStartNum(selectedCompartment.startNum);
      setEndNum(selectedCompartment.endNum);
      setSelectedCategories(selectedCompartment.categories.map((c) => c._id));
    } else {
      if (compartments.length > 0) {
        const lastCompartment = compartments.reduce(
          (r, v) => (r ? (v.order > r.order ? v : r) : v),
          null
        );
        setStartNum(lastCompartment.endNum + 1);
        setEndNum(lastCompartment.endNum + 40);
        setSelectedCategories([]);
      }
    }
  }, [selectedCompartment]);

  const submitHandler = async (e) => {
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      setFormValidated(true);
      return;
    }
    if (e) {
      e.preventDefault();
    }
    try {
      dispatch({ type: "UPDATE_REQUEST" });
      !selectedCompartment
        ? await axios.post("/api/compartments", [
            ...compartments,
            {
              name,
              startNum,
              endNum,
              categories: selectedCategories,
              order:
                compartments.length === 0
                  ? 1
                  : compartments.reduce(
                      (l, f) => (f.order > l ? f.order : l),
                      0
                    ) + 1,
            },
          ])
        : await axios.post(`/api/compartments`, [
            ...compartments
              .filter((c) => c.status)
              .map((c) =>
                c._id === selectedCompartment._id
                  ? {
                      name,
                      startNum,
                      endNum,
                      categories: selectedCategories,
                      order: selectedCompartment.order,
                      _id: selectedCompartment._id,
                    }
                  : c
              ),
          ]);

      setShowCompartmentEditor(false);
      setCompartmentEditorOperationOk(true);
      dispatch({
        type: "UPDATE_SUCCESS",
      });
      toast.success("Bölüm basarili bir sekilde kaydedildi");
    } catch (err) {
      toast.error(getError(err));
      dispatch({ type: "UPDATE_FAIL" });
    }
  };

  return (
    <div>
      {loading ? (
        <LoadingBox></LoadingBox>
      ) : error ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : (
        <Form onSubmit={submitHandler} noValidate validated={formValidated}>
          <Form.Group className="mb-3 ">
            <Form.Label>Bölüm Adı</Form.Label>
            <Form.Control
              value={name}
              onChange={(e) => setName(capitalize(e.target.value))}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Masa Numarası Başlangıç</Form.Label>
            <Form.Control
              value={startNum}
              type="number"
              onChange={(e) => setStartNum(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Masa Numarası Bitiş</Form.Label>
            <Form.Control
              value={endNum}
              type="number"
              onChange={(e) => setEndNum(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Kategoriler</Form.Label>
            <div className="text-muted small-font">
              Bu bölümde sadece seçeceğim kategorilerdeki ürünler satılacak!
            </div>
            <div className="mb-3">
              <ReactSelect
                options={leafCategories.map((c) => {
                  return { value: c._id, label: c.name };
                })}
                isMulti={true}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{
                  Option,
                }}
                onChange={(selected) => {
                  setSelectedCategories(selected.map((entry) => entry.value));
                }}
                allowSelectAll={true}
                value={leafCategories
                  .filter((c) => selectedCategories.includes(c._id))
                  .map((c) => {
                    return { value: c._id, label: c.name };
                  })}
              />
            </div>
          </Form.Group>

          <div className="mb-3">
            <Button
              disabled={loadingUpdate}
              type="submit"
              variant="light"
              className="text-primary border-primary"
            >
              {!selectedCompartment ? "Kaydet" : "Güncelle"}
            </Button>
            {loadingUpdate && <LoadingBox></LoadingBox>}
          </div>
        </Form>
      )}
    </div>
  );
}
